import { createFeature, createReducer, on } from '@ngrx/store'
import { OfficeState } from './office.state'
import {
  createOffice,
  createOfficeFailure,
  createOfficeSuccess,
  loadOffices,
  loadOfficesFailure,
  loadOfficesSuccess,
  resetOfficeState,
  updateOffice,
  updateOfficeFailure,
  updateOfficeSuccess
} from './office.actions'

export const initialState: OfficeState = {
  totalCount: 0,
  offices: [],
  loading: false,
  error: null
}

// Create the office reducer
export const officeReducer = createReducer(
  initialState,
  on(loadOffices, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadOfficesSuccess, (state, { totalCount, offices }) => ({
    ...state,
    totalCount,
    offices,
    loading: false,
    error: null
  })),
  on(loadOfficesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createOffice, state => ({ ...state, loading: true })),
  on(createOfficeSuccess, (state, { office }) => ({
    ...state,
    offices: [...state.offices, office],
    loading: false
  })),
  on(createOfficeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateOffice, state => ({ ...state, loading: true })),
  on(updateOfficeSuccess, (state, { office }) => ({
    ...state,
    office,
    loading: false
  })),
  on(updateOfficeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(resetOfficeState, () => initialState)
)

// Create the feature for the office state
export const officeFeature = createFeature({
  name: 'office', // Feature name
  reducer: officeReducer
})
export type { OfficeState }
// Export the feature's selectors
export const { name, reducer, selectOffices, selectLoading, selectError } = officeFeature
